import React, {Component} from "react";
import {connect} from "react-redux";

import * as navigationActions from "../../../actions/navigationActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as modelHelper from "../../../helpers/modelHelper";

import Modal from "../generic/Modal";
import CloseButton from "../generic/CloseButton";

class WebViewModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseWebViewModalAction();
    };

    getTitle = () => {
        if (this.props.params !== undefined && this.props.params.title) {
            return this.props.params.title;
        }

        return "";
    };

    getLink = () => {
        if (this.props.params !== undefined && this.props.params.link) {
            return this.props.params.link;
        }

        return "";
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(this.getTitle())}
                content={modelHelper.buildModalSection(
                    <webview src={this.getLink()} style={{width: "100%", height: "100%"}} />
                )}
                footer={modelHelper.buildModalSection(<CloseButton onClick={this.handleCloseModalClick} />)}
                styles={{
                    height: "80%",
                    width: "70%"
                }}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseWebViewModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.WEBVIEW_MODAL));
        }
    };
};

export default WebViewModal = connect(mapStoreToProps, mapDispatchToProps)(WebViewModal);
